import deDE from './de-DE.json';
import deAT from './de-AT.json';
import deCH from './de-CH.json';
import frCH from './fr-CH.json';
var messages = {
    'de-DE': deDE,
    'de-AT': deAT,
    'de-CH': deCH,
    'fr-CH': frCH,
};
export default messages;
//# sourceMappingURL=index.js.map